// @ts-check
/**
 * Lightweight runtime guards for API responses.
 * @param {any} data
 * @param {string[]} requiredKeys
 * @param {string} caller
 */
export function assertShape(data, requiredKeys, caller) {
  if (data == null || typeof data !== 'object' || Array.isArray(data)) {
    console.error(`[API Guard] ${caller}: expected object, got`, typeof data, data);
    throw new Error(`${caller}: unexpected API response (expected object)`);
  }
  const missing = requiredKeys.filter((key) => !(key in data));
  if (missing.length > 0) {
    console.error(`[API Guard] ${caller}: missing keys [${missing.join(', ')}] in`, data);
    throw new Error(`${caller}: API response missing fields: ${missing.join(', ')}`);
  }
}

/**
 * @param {any} data
 * @param {string} caller
 * @param {string[]} [itemKeys]
 */
export function assertArray(data, caller, itemKeys) {
  if (!Array.isArray(data)) {
    console.error(`[API Guard] ${caller}: expected array, got`, typeof data, data);
    throw new Error(`${caller}: unexpected API response (expected array)`);
  }
  if (itemKeys && data.length > 0) {
    const first = data[0];
    const missing = itemKeys.filter((key) => !(key in first));
    if (missing.length > 0) {
      console.error(`[API Guard] ${caller}: array items missing keys [${missing.join(', ')}] in first element`, first);
      throw new Error(`${caller}: API array items missing fields: ${missing.join(', ')}`);
    }
  }
}
